

import RepeaterBlock
    from "../../../../../orange/broadband/demands/showcase/internetofferdetail/components/RepeaterBlock.vue";

interface BoxBenefitDto {
    label: string
    description: string
    icon?: string | null
}

interface InternetBoxBlockDTO {
    name: string
    visual?: any
    title: string
    firstAttribute: BoxBenefitDto
    secondAttribute: BoxBenefitDto
    thirdAttribute: BoxBenefitDto
    otherAttributes?: BoxBenefitDto[]
}

export default {
    name: "InternetLiveBoxBlock",
    components: {
        RepeaterBlock
    },
    props: {
        internetLiveBoxBlock: {
            type: Object as () => InternetBoxBlockDTO | null,
            default: null,
            required: false
        },
        repeaterBlocDto: {
            type: Object,
            default: null,
            required: false
        }
    }
}
